import { createContext } from 'react';

import { FolderTreeOpenModal } from '../types';

type Context = {
  expandedIds: Set<string>;
  onToggleExpand: (id: string) => void;
  openModal: (modal: FolderTreeOpenModal) => void;
};

export const initialState: Context = {
  expandedIds: new Set(),
  onToggleExpand: () => {},
  openModal: () => {},
};

const FolderTreeContext = createContext<Context>(initialState);

export default FolderTreeContext;
